var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamondIconBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44312 8.61487H25.5568M10.9617 1L8.42341 8.61487L13.4999 23.21L18.5765 8.61487L16.0382 1M14.28 22.9086L25.6497 9.26486C25.8425 9.03362 25.9388 8.918 25.9756 8.78896C26.0081 8.67517 26.0081 8.55457 25.9756 8.44078C25.9388 8.31172 25.8425 8.19611 25.6497 7.96488L20.1501 1.36532C20.0382 1.23103 19.9824 1.1639 19.9137 1.11563C19.8529 1.07286 19.7851 1.04109 19.7134 1.02179C19.6323 1 19.545 1 19.3701 1H7.62982C7.45501 1 7.36761 1 7.28662 1.02179C7.21486 1.04109 7.14705 1.07286 7.08627 1.11563C7.01768 1.1639 6.96173 1.23103 6.84983 1.36532L1.3502 7.96488C1.15751 8.1961 1.06116 8.31172 1.02434 8.44078C0.991887 8.55457 0.991887 8.67517 1.02434 8.78894C1.06116 8.918 1.15751 9.03362 1.3502 9.26486L12.7201 22.9086C12.9878 23.2301 13.1217 23.3908 13.2822 23.4494C13.4228 23.5008 13.5771 23.5008 13.7179 23.4494C13.8781 23.3908 14.0122 23.2301 14.28 22.9086Z",
    stroke: "url(#paint0_linear_8473_33293)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8473_33293",
    x1: 1,
    y1: 12.244,
    x2: 26,
    y2: 12.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIconBottom);
export default __webpack_public_path__ + "static/media/DiamondIconBottom.1c512f443e8fb4f5d009f34f1b16d73a.svg";
export { ForwardRef as ReactComponent };